import React, { useEffect } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';

const PrivacyPage = () => {
  useEffect(() => {
    document.title = 'Privacy Policy | Nexus LBE';
  }, []);

  return (
    <div className="relative">
      {/* Hero */}
      <section className="relative overflow-hidden pt-20 pb-12 lg:pt-28 lg:pb-16 gradient-sunset">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-screen-xl text-center">
          <Badge variant="outline" className="mb-4">Legal</Badge>
          <h1 className="font-['Geist'] tracking-tight text-4xl sm:text-5xl mb-4">
            Privacy Policy
          </h1>
          <p className="text-muted-foreground">Last updated: January 2025</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-10 lg:py-14">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
          <Card>
            <CardContent className="p-8 md:p-12 prose prose-sm max-w-none">
              <div className="space-y-8 text-muted-foreground">
                <div>
                  <h2 className="font-['Geist'] text-2xl text-foreground mb-3">Introduction</h2>
                  <p className="leading-relaxed">
                    Nexus LBE ("we", "our", or "us") respects your privacy and is committed to protecting your personal data. 
                    This privacy policy will inform you about how we handle your personal data when you visit our website and 
                    tell you about your privacy rights.
                  </p>
                </div>

                <div>
                  <h2 className="font-['Geist'] text-2xl text-foreground mb-3">Information We Collect</h2>
                  <p className="leading-relaxed mb-3">
                    When you contact us through our website, we may collect:
                  </p>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Name and contact information (email, phone)</li>
                    <li>Company name and role</li>
                    <li>Message content and inquiry details</li>
                    <li>Technical data (IP address, browser type, device information)</li>
                  </ul>
                </div>

                <div>
                  <h2 className="font-['Geist'] text-2xl text-foreground mb-3">How We Use Your Information</h2>
                  <p className="leading-relaxed mb-3">
                    We use your personal data to:
                  </p>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Respond to your inquiries and communications</li>
                    <li>Provide information about our services and partnership opportunities</li>
                    <li>Improve our website and services</li>
                    <li>Comply with legal obligations</li>
                  </ul>
                </div>

                <div>
                  <h2 className="font-['Geist'] text-2xl text-foreground mb-3">Data Security</h2>
                  <p className="leading-relaxed">
                    We implement appropriate technical and organizational measures to protect your personal data against 
                    unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the 
                    internet is 100% secure.
                  </p>
                </div>

                <div>
                  <h2 className="font-['Geist'] text-2xl text-foreground mb-3">Your Rights</h2>
                  <p className="leading-relaxed mb-3">
                    Under data protection law, you have rights including:
                  </p>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>The right to access your personal data</li>
                    <li>The right to rectification of inaccurate data</li>
                    <li>The right to erasure of your data</li>
                    <li>The right to restrict or object to processing</li>
                    <li>The right to data portability</li>
                  </ul>
                </div>

                <div>
                  <h2 className="font-['Geist'] text-2xl text-foreground mb-3">Cookies</h2>
                  <p className="leading-relaxed">
                    Our website may use cookies to enhance user experience. You can set your browser to refuse cookies, 
                    though this may limit some functionality.
                  </p>
                </div>

                <div>
                  <h2 className="font-['Geist'] text-2xl text-foreground mb-3">Contact Us</h2>
                  <p className="leading-relaxed">
                    If you have questions about this privacy policy or wish to exercise your rights, please contact us at:
                    <br />
                    <a href="mailto:hello@nexuslbe.com" className="text-primary hover:text-[hsl(17_62%_34%)] font-medium">
                      hello@nexuslbe.com
                    </a>
                  </p>
                </div>

                <div className="pt-4 border-t border-border">
                  <p className="text-xs">
                    This is a placeholder privacy policy. Nexus LBE will provide a comprehensive privacy policy 
                    in accordance with applicable data protection regulations before launching commercial operations.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;
